<form #form="ngForm" autocomplete="off">
    <ng-container *ngIf="jobBoard">
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{ 'forms.applicant-tracker.jobBoardTitle' | appTranslate }}</mat-label>
                <input
                    type="text"
                    [placeholder]="
                        { key: 'forms.applicant-tracker.companyNameJobBoard', params: { companyName: company.name } }
                            | appTranslate
                    "
                    required
                    #title="ngModel"
                    name="title"
                    [(ngModel)]="jobBoard.title"
                    matInput
                />
                <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-12">
                <mat-label>{{ 'forms.applicant-tracker.companyWebsite' | appTranslate }}</mat-label>
                <input
                    type="text"
                    [placeholder]="company.website || 'https://www.example.com'"
                    required
                    #companyWebsite="ngModel"
                    name="companyWebsite"
                    [(ngModel)]="jobBoard.companyUrl"
                    style="border: none"
                    matInput
                />
                <mat-error *ngIf="companyWebsite.invalid">{{ companyWebsite.errors | formErrors }}</mat-error>
            </mat-form-field>
            <label id="job-board-address-label" class="margin-bottom-1">{{
                'forms.applicant-tracker.jobBoardAddress' | appTranslate
            }}</label>
            <div class="app-grid align-items-baseline">
                <label class="columns-1">https://</label>
                <mat-form-field class="columns-8 no-labels">
                    <input
                        aria-labelledby="job-board-address-label"
                        type="text"
                        [placeholder]="'forms.applicant-tracker.nothing' | appTranslate"
                        required
                        #companySlug="ngModel"
                        name="companySlug"
                        [(ngModel)]="jobBoard.companySlug"
                        matInput
                        pattern="^(?![-])[a-zA-Z0-9-]+(?<![-])$"
                    />
                    <mat-error *ngIf="companySlug.invalid">{{
                        'forms.applicant-tracker.addressMustOnlyIncludeTheFollowingSymbolsAToZToAndCanIncludeBetw'
                            | appTranslate
                    }}</mat-error>
                </mat-form-field>
                <label class="columns-3">.{{ jobBoardDomain }}</label>
            </div>
            <mat-form-field class="columns-12 margin-top-1">
                <mat-label>{{ 'forms.applicant-tracker.successMessage' | appTranslate }}</mat-label>
                <textarea
                    placeholder="{{
                        'forms.applicant-tracker.youHaveSuccessfullyAppliedForThePosition' | appTranslate
                    }}"
                    #successMessage="ngModel"
                    name="successMessage"
                    [(ngModel)]="jobBoard.successMessage"
                    matInput
                >
                </textarea>
                <mat-error *ngIf="successMessage.invalid">{{ successMessage.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
